unit View.Pagamentos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewPagamentosList = class(TForm)
    btNew: TButton;
    PagamentosDataset: TXDataWebDataSet;
    PagamentosDatasetid: TIntegerField;
    PagamentosDatasetaliado_id: TIntegerField;
    PagamentosDatasetdata_base_id: TIntegerField;
    PagamentosDatasetapagar_id: TIntegerField;
    PagamentosDatasetconta_id: TIntegerField;
    PagamentosDatasetmodalidade_id: TIntegerField;
    PagamentosDatasetplano_contas_id: TIntegerField;
    PagamentosDatasetvalor: TFloatField;
    PagamentosDatasetvalor_desconto: TFloatField;
    PagamentosDatasetvalor_multa: TFloatField;
    PagamentosDatasetvalor_juros: TFloatField;
    PagamentosDatasetvalor_outros: TFloatField;
    PagamentosDatasetdata: TDateTimeField;
    PagamentosDatasetcodigo_interno: TIntegerField;
    PagamentosDatasetexcluido: TBooleanField;
    PagamentosDatasetinclusao: TDateTimeField;
    PagamentosDatasetalteracao: TDateTimeField;
    PagamentosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewPagamentosList: TFViewPagamentosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPagamentosList }

procedure TFViewPagamentosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewPagamentosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPagamentosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewPagamentosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewPagamentosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewPagamentosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewPagamentosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      PagamentosDataset.Connection.Model.DefaultSchema.FindEntityType(PagamentosDataset.EntitySetName),
      PagamentosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewPagamentosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('pagamentos', 'active');
  TUtils.SetValorDicionarioClasses('pagamentos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_pagamentos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    PagamentosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewPagamentosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.pagamentos.list.pagination.info');
  btNew := TButton.Create('view.pagamentos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.pagamentos.list.table');
  cbPageSize := TComboBox.Create('view.pagamentos.list.cbPageSize');
  edSearch := TEdit.Create('view.pagamentos.list.search');
  lcPaginator := TListControl.Create('view.pagamentos.list.pagination');
  PagamentosDataset := TXDataWebDataSet.Create(Self);
  PagamentosDatasetid := TIntegerField.Create(Self);
  PagamentosDatasetaliado_id := TIntegerField.Create(Self);
  PagamentosDatasetdata_base_id := TIntegerField.Create(Self);
  PagamentosDatasetapagar_id := TIntegerField.Create(Self);
  PagamentosDatasetconta_id := TIntegerField.Create(Self);
  PagamentosDatasetmodalidade_id := TIntegerField.Create(Self);
  PagamentosDatasetplano_contas_id := TIntegerField.Create(Self);
  PagamentosDatasetvalor := TFloatField.Create(Self);
  PagamentosDatasetvalor_desconto := TFloatField.Create(Self);
  PagamentosDatasetvalor_multa := TFloatField.Create(Self);
  PagamentosDatasetvalor_juros := TFloatField.Create(Self);
  PagamentosDatasetvalor_outros := TFloatField.Create(Self);
  PagamentosDatasetdata := TDateTimeField.Create(Self);
  PagamentosDatasetcodigo_interno := TIntegerField.Create(Self);
  PagamentosDatasetexcluido := TBooleanField.Create(Self);
  PagamentosDatasetinclusao := TDateTimeField.Create(Self);
  PagamentosDatasetalteracao := TDateTimeField.Create(Self);
  PagamentosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  PagamentosDataset.BeforeLoadDFMValues;
  PagamentosDatasetid.BeforeLoadDFMValues;
  PagamentosDatasetaliado_id.BeforeLoadDFMValues;
  PagamentosDatasetdata_base_id.BeforeLoadDFMValues;
  PagamentosDatasetapagar_id.BeforeLoadDFMValues;
  PagamentosDatasetconta_id.BeforeLoadDFMValues;
  PagamentosDatasetmodalidade_id.BeforeLoadDFMValues;
  PagamentosDatasetplano_contas_id.BeforeLoadDFMValues;
  PagamentosDatasetvalor.BeforeLoadDFMValues;
  PagamentosDatasetvalor_desconto.BeforeLoadDFMValues;
  PagamentosDatasetvalor_multa.BeforeLoadDFMValues;
  PagamentosDatasetvalor_juros.BeforeLoadDFMValues;
  PagamentosDatasetvalor_outros.BeforeLoadDFMValues;
  PagamentosDatasetdata.BeforeLoadDFMValues;
  PagamentosDatasetcodigo_interno.BeforeLoadDFMValues;
  PagamentosDatasetexcluido.BeforeLoadDFMValues;
  PagamentosDatasetinclusao.BeforeLoadDFMValues;
  PagamentosDatasetalteracao.BeforeLoadDFMValues;
  PagamentosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewPagamentosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'apagar_id';
      Title := 'apagar_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_id';
      Title := 'conta_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_id';
      Title := 'modalidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas_id';
      Title := 'plano_contas_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_desconto';
      Title := 'valor_desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_multa';
      Title := 'valor_multa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_juros';
      Title := 'valor_juros';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_outros';
      Title := 'valor_outros';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data';
      Title := 'data';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    PagamentosDataset.SetParentComponent(Self);
    PagamentosDataset.Name := 'PagamentosDataset';
    PagamentosDataset.EntitySetName := 'Pagamentos';
    PagamentosDataset.Connection := DMConnection.ApiConnection;
    PagamentosDataset.Left := 72;
    PagamentosDataset.Top := 144;
    PagamentosDatasetid.SetParentComponent(PagamentosDataset);
    PagamentosDatasetid.Name := 'PagamentosDatasetid';
    PagamentosDatasetid.FieldName := 'id';
    PagamentosDatasetid.Required := True;
    PagamentosDatasetaliado_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetaliado_id.Name := 'PagamentosDatasetaliado_id';
    PagamentosDatasetaliado_id.FieldName := 'aliado_id';
    PagamentosDatasetaliado_id.Required := True;
    PagamentosDatasetdata_base_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetdata_base_id.Name := 'PagamentosDatasetdata_base_id';
    PagamentosDatasetdata_base_id.FieldName := 'data_base_id';
    PagamentosDatasetdata_base_id.Required := True;
    PagamentosDatasetapagar_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetapagar_id.Name := 'PagamentosDatasetapagar_id';
    PagamentosDatasetapagar_id.FieldName := 'apagar_id';
    PagamentosDatasetapagar_id.Required := True;
    PagamentosDatasetconta_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetconta_id.Name := 'PagamentosDatasetconta_id';
    PagamentosDatasetconta_id.FieldName := 'conta_id';
    PagamentosDatasetmodalidade_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetmodalidade_id.Name := 'PagamentosDatasetmodalidade_id';
    PagamentosDatasetmodalidade_id.FieldName := 'modalidade_id';
    PagamentosDatasetplano_contas_id.SetParentComponent(PagamentosDataset);
    PagamentosDatasetplano_contas_id.Name := 'PagamentosDatasetplano_contas_id';
    PagamentosDatasetplano_contas_id.FieldName := 'plano_contas_id';
    PagamentosDatasetvalor.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor.Name := 'PagamentosDatasetvalor';
    PagamentosDatasetvalor.FieldName := 'valor';
    PagamentosDatasetvalor_desconto.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor_desconto.Name := 'PagamentosDatasetvalor_desconto';
    PagamentosDatasetvalor_desconto.FieldName := 'valor_desconto';
    PagamentosDatasetvalor_multa.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor_multa.Name := 'PagamentosDatasetvalor_multa';
    PagamentosDatasetvalor_multa.FieldName := 'valor_multa';
    PagamentosDatasetvalor_juros.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor_juros.Name := 'PagamentosDatasetvalor_juros';
    PagamentosDatasetvalor_juros.FieldName := 'valor_juros';
    PagamentosDatasetvalor_outros.SetParentComponent(PagamentosDataset);
    PagamentosDatasetvalor_outros.Name := 'PagamentosDatasetvalor_outros';
    PagamentosDatasetvalor_outros.FieldName := 'valor_outros';
    PagamentosDatasetdata.SetParentComponent(PagamentosDataset);
    PagamentosDatasetdata.Name := 'PagamentosDatasetdata';
    PagamentosDatasetdata.FieldName := 'data';
    PagamentosDatasetcodigo_interno.SetParentComponent(PagamentosDataset);
    PagamentosDatasetcodigo_interno.Name := 'PagamentosDatasetcodigo_interno';
    PagamentosDatasetcodigo_interno.FieldName := 'codigo_interno';
    PagamentosDatasetcodigo_interno.Required := True;
    PagamentosDatasetexcluido.SetParentComponent(PagamentosDataset);
    PagamentosDatasetexcluido.Name := 'PagamentosDatasetexcluido';
    PagamentosDatasetexcluido.FieldName := 'excluido';
    PagamentosDatasetinclusao.SetParentComponent(PagamentosDataset);
    PagamentosDatasetinclusao.Name := 'PagamentosDatasetinclusao';
    PagamentosDatasetinclusao.FieldName := 'inclusao';
    PagamentosDatasetalteracao.SetParentComponent(PagamentosDataset);
    PagamentosDatasetalteracao.Name := 'PagamentosDatasetalteracao';
    PagamentosDatasetalteracao.FieldName := 'alteracao';
    PagamentosDatasetexclusao.SetParentComponent(PagamentosDataset);
    PagamentosDatasetexclusao.Name := 'PagamentosDatasetexclusao';
    PagamentosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := PagamentosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    PagamentosDataset.AfterLoadDFMValues;
    PagamentosDatasetid.AfterLoadDFMValues;
    PagamentosDatasetaliado_id.AfterLoadDFMValues;
    PagamentosDatasetdata_base_id.AfterLoadDFMValues;
    PagamentosDatasetapagar_id.AfterLoadDFMValues;
    PagamentosDatasetconta_id.AfterLoadDFMValues;
    PagamentosDatasetmodalidade_id.AfterLoadDFMValues;
    PagamentosDatasetplano_contas_id.AfterLoadDFMValues;
    PagamentosDatasetvalor.AfterLoadDFMValues;
    PagamentosDatasetvalor_desconto.AfterLoadDFMValues;
    PagamentosDatasetvalor_multa.AfterLoadDFMValues;
    PagamentosDatasetvalor_juros.AfterLoadDFMValues;
    PagamentosDatasetvalor_outros.AfterLoadDFMValues;
    PagamentosDatasetdata.AfterLoadDFMValues;
    PagamentosDatasetcodigo_interno.AfterLoadDFMValues;
    PagamentosDatasetexcluido.AfterLoadDFMValues;
    PagamentosDatasetinclusao.AfterLoadDFMValues;
    PagamentosDatasetalteracao.AfterLoadDFMValues;
    PagamentosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
